// extracted by mini-css-extract-plugin
export default {"wrapper":"cardProjectTooltip_wrapper__1Iufb"};